import { useState } from 'react'

import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent } from '@mui/material'

import { FplDialogTitle } from 'components/common'

import TopBookingItem from './TopBookingItem'

interface IProps {
  topBookingList: any
  loadingTopBookings: boolean
  open: boolean
  setOpen: any
  onSelectTopBooking: (bookingId: number) => void
  title?: string
}

const SelectTopBookingDialog = (props: IProps) => {
  const {
    topBookingList,
    loadingTopBookings,
    open,
    setOpen,
    onSelectTopBooking,
    title = 'Top Bookings',
  } = props
  const [selectedBookingId, setSelectedBookingId] = useState<number | null>(null)

  const handleClose = () => {
    setOpen(false)
  }
  const handleSelectBooking = (bookingId: number) => {
    setSelectedBookingId(bookingId)
    onSelectTopBooking(bookingId)
  }

  return (
    <Dialog
      maxWidth='md'
      open={open}
      onClose={handleClose}
      aria-labelledby='select-top-booking-dialog'>
      <FplDialogTitle id='select-top-booking-dialog' onClose={handleClose}>
        {title}
      </FplDialogTitle>

      <DialogContent>
        {loadingTopBookings ? (
          <Box display='flex' justifyContent='center' alignItems='center' height='150px'>
            <CircularProgress />
          </Box>
        ) : (
          topBookingList?.map((b) => (
            <TopBookingItem
              key={b.bookingId}
              bookingId={b.bookingId}
              firstCollectionAddress={b.firstCollectionAddress}
              lastDeliveryAddress={b.lastDeliveryAddress}
              tariffName={b.tariffName}
              isSelected={b.bookingId === selectedBookingId}
              onSelectTopBooking={() => handleSelectBooking(b.bookingId)}
            />
          ))
        )}
      </DialogContent>

      <DialogActions>
        <Button variant='contained' color='grey' onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SelectTopBookingDialog
